import get from 'lodash/get'

export const getNumberOfWebcastsPerPeriod = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  const enabledFeature = channelData.features.find(({ name, enabled, value }) => name === 'maxCommunicationsPerPeriod' && enabled === true)
  if (!enabledFeature) {

    const disabledFeature = channelData.features.find(({ name, enabled }) => name === 'maxCommunicationsPerPeriod' && enabled === false)

    if (disabledFeature) {

        return 'Unlimited'

    } else {

        return false

    }

  }

  return enabledFeature.value

}
